export function getSelectedCategories(programs, interview) {
    let selectedCategoriesObj = programs.data.filter(
        x => x.eligibilityDeterminationStatus.name === "Action Complete" && x.eligibilityStatus.name === "Approved"
    );

    if (selectedCategoriesObj.length === 0) {
        selectedCategoriesObj = programs.data.filter(
            x => x.eligibilityDeterminationStatus.name === "Pending Decision" && x.eligibilityStatus.name === "Pending"
        );
    }

    let selectedCategories = selectedCategoriesObj.map(x => ({
        assistanceCategory: x.assistanceCategory,
        nickName: x.programNickname,
    }));
    if (interview.coverage.isVictimOfViolentCrime) {
        selectedCategories = [...selectedCategories, { assistanceCategory: "Victim Of Violent Crime" }];
    }
    return selectedCategories;
}
export function getJurisdiction(selectedCategoriesObj, customerJurisdictions) {
    let jurisdiction = selectedCategoriesObj.map(x => x.jurisdiction)[0];
    let jurisdictions = [jurisdiction];

    if (jurisdiction === "USA") {
        jurisdictions = customerJurisdictions;
    }
    return jurisdictions;
}
